// extracted by mini-css-extract-plugin
export default {"table":"Table_table__Hz-Rl","breathing":"Table_breathing__M1pY-"};